import type { QueryObserverOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

export const usePlacesDetailsQuery = (
  requestOptions: {
    placeId: string;
    requestedLanguage?: string;
    fieldsRequest: google.maps.places.FetchFieldsRequest;
  },
  queryOptions?: Omit<
    QueryObserverOptions<{ place: google.maps.places.Place } | null>,
    "queryKey" | "queryFn"
  >,
) => {
  const data = useQuery({
    queryKey: ["placesDetails", requestOptions],
    queryFn: async () => {
      return await new google.maps.places.Place({
        id: requestOptions.placeId,
        requestedLanguage: requestOptions.requestedLanguage,
      }).fetchFields(requestOptions.fieldsRequest);
    },
    ...queryOptions,
  });

  return data;
};
